import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeHistorySatResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }
  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeHistorySatResponse(value));
const isHistorySatAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }
    if (typeof value !== 'string') {
      return false;
    }
  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
  }

  return normalizedValue === 'erro_auth';
  });
};

const handleHistorySatError = (xhr, reject, rejectMessage) => {
  if (isHistorySatAuthError(xhr)) {
    showDuplicateLoginAlert();
  }
  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};
const ajaxHistorySatEvent = ({
  type,
  pp,
  ll,
  dd,
  tk,
  parseType = 'base64',
  rejectMessage = 'erro',
  extraData = {},
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
  type,
  dataType: 'text',
  headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
  pp: base64_encode(pp),
  ll: base64_encode(ll),
  dd: base64_encode(JSON.stringify(dd)),
        tk,
        ...extraData,
      },
      success: function (data) {
        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }
        resolve([200, data]);
      },
      error: function (xhr) {
        handleHistorySatError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: err + ' Server Error' }]);
  }
});
const RestHistorySatPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'deleteMarcador':
      return ajaxHistorySatEvent({
        type: 'Post',
  pp: 'sat',
  ll: 'deleteMarcadores',
  dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downXML':
      return ajaxHistorySatEvent({
        type: 'Get',
        pp: 'sat',
  ll: 'dwnXml',
  dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
  tk: token,
      });
    case 'downloadLote':
      return ajaxHistorySatEvent({
  type: 'Post',
  pp: 'sat',
  ll: 'downloadLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLoteTodas':
      return ajaxHistorySatEvent({
        type: 'Post',
  pp: 'sat',
  ll: 'downloadLoteTodas',
  dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'eventos':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
  ll: 'situacao',
  dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
  tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 1 },
      });
    case 'hideMarcador':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'hideMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'investigar':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'investigar',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'manifestacao':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'manifestacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'pesqSat':
      return ajaxHistorySatEvent({
        type: 'Get',
        pp: 'sat',
        ll: 'pesqSat',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'printDaSat':
      return ajaxHistorySatEvent({
        type: 'Get',
        pp: 'sat',
        ll: 'printDaSat',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'printCupom':
      return ajaxHistorySatEvent({
        type: 'Get',
        pp: 'sat',
        ll: 'printCupom',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'salvaConfigTabela':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'updateConfigTabela',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost, null, 2))],
        tk: token,
        extraData: { cf: Arr_.dataPost },
      });
    case 'salvaNovoMarcador':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'salvaNovoMarcadorSat',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: { tipo: 'sat' },
      });
    case 'setMarcador':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'setMarcador',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'showMarcador':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'showMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'situacao':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 0 },
      });
    case 'updateAnotacao':
      return ajaxHistorySatEvent({
        type: 'Post',
        pp: 'sat',
        ll: 'updateAnotacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestHistorySatGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'getConfigTableSat':
      return ajaxHistorySatEvent({
        type: 'Get',
        pp: 'sat',
        ll: 'getConfigTableSat',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
      });
    case 'getItensSat':
      return ajaxHistorySatEvent({
        type: 'Get',
        pp: 'sat',
        ll: 'getItensSat',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getMarcadoresSat':
      return ajaxHistorySatEvent({
        type: 'Get',
        pp: 'sat',
        ll: 'getMarcadoresSat',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getVinculados':
      return ajaxHistorySatEvent({
        type: 'Get',
        pp: 'sat',
        ll: 'getVinculadosSat',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestHistorySatPost, RestHistorySatGet };
